import React from 'react'
import { Box, CircularProgress, Typography } from '@material-ui/core'

import useStyles from './styles'

const StepItem = ({ label, Icon, isActive, isLast }) => {
  const classes = useStyles()

  return (
    <Box className={classes.stepItem}>
      <Box className={classes.iconColumn}>
        <Box className={classes.iconWrapper}>
          {isActive ? (
            <CircularProgress
              size={14}
              thickness={3}
              className={classes.spinner}
            />
          ) : Icon ? (
            <Icon size={14} className={classes.stepIcon} />
          ) : null}
        </Box>
        {!isLast && <Box className={classes.connector} />}
      </Box>
      <Box className={classes.stepContent}>
        <Typography className={classes.stepLabel}>{label}</Typography>
      </Box>
    </Box>
  )
}

export default StepItem
